import { promiseTimeout } from './promiseTimeout';

/**
 * This function delays a promise resolving for a passed `timeout`
 * It could be helpful, when animation delay is required.
 * @export
 * @template P
 * @param {Promise<P>} promise
 * @param {number} timeout
 * @returns {Promise<P>}
 */
function delayPromiseResolving<P>(promise: Promise<P>, timeout: number): Promise<P> {
    return new Promise((resolve, reject) =>
        Promise.all([promise, promiseTimeout(timeout)])
            .then(([payload]) => resolve(payload))
            .catch(reject),
    );
}

export default delayPromiseResolving;
